import React from "react";
import bigPrizeImage from "../../assets/big-prize.png";
import placeholderImage from "../../assets/another-prize.png";
import ShareCard from "../../common/ShareCard";
import styles from "./PrizesFragment.module.css";
import PrizesInfoCard from "../../common/PrizesInfoCard";

const PrizesFragment = ({ goToRules }) => {
	return (
		<div className={styles.container}>
			<div className={styles.prizesContainer}>
				<PrizesInfoCard onButtonClick={goToRules} />

				{/* Grand Prize */}
				<div className={styles.prizeCard}>
					<div>
						<img className={styles.prizeImage} src={bigPrizeImage} alt="Big prize" />
					</div>
					<div className={styles.prizeCardContent} style={{ paddingTop: 0 }}>
						<h2 className={styles.prizeTitle}>Grand Prize – Watch Arsenal at the Emirates Stadium</h2>
						<p className={styles.prizeDescription}>
							Win a trip for two to watch Arsenal play at the Emirates Stadium in London, including flights (if required), accommodation
							(if required) and £500 spending money.
						</p>
					</div>
				</div>

				{/* Round Winner */}
				<div className={styles.prizeCard}>
					<div>
						<img className={styles.prizeImage} src={placeholderImage} alt="Big prize" />
					</div>
					<div className={styles.prizeCardContent}>
						<h2 className={styles.prizeTitle}>Round Winner – Cash Prize in your Betway account</h2>
						<p className={styles.prizeDescription}>
							The top performer every week will win €150 (or currency equivalent – see ‘Rules’ section) as Cash deposited into their
							Betway account.
						</p>
					</div>
				</div>

				{/* Weekly Winner */}
				<div className={styles.prizeCard}>
					<div>
						<img className={styles.prizeImage} src={placeholderImage} alt="Big prize" />
					</div>
					<div className={styles.prizeCardContent}>
						<h2 className={styles.prizeTitle}>Places 2-10 every round – Cash Prize in your Betway account</h2>
						<p className={styles.prizeDescription}>
							Those finishing 2nd to 10th every week will also receive Cash prizes in their Betway account. See the ‘Rules’ section for
							the exact amounts that you can win.
						</p>
					</div>
				</div>

				{/* Invite Friends */}
				<ShareCard />
			</div>
		</div>
	);
};

export default PrizesFragment;
